import { InlineChildren, Icon } from '@doordash/design-language';
import React from 'react';
import Page from './Page.js';
import { PageNav } from './styles.js';
import { shouldShowPage } from './utils.js';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Pagination = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Pagination, _React$PureComponent);

  var _super = _createSuper(Pagination);

  function Pagination() {
    var _this;

    _classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "prevPage", function () {
      var _this$props = _this.props,
          currentPage = _this$props.currentPage,
          changePage = _this$props.changePage;
      var prevPageNumber = currentPage === 1 ? currentPage : currentPage - 1;
      changePage(prevPageNumber);
    });

    _defineProperty(_assertThisInitialized(_this), "nextPage", function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          numPages = _this$props2.numPages,
          changePage = _this$props2.changePage;
      var nextPageNumber = currentPage === numPages ? currentPage : currentPage + 1;
      changePage(nextPageNumber);
    });

    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          _this$props3$accessib = _this$props3.accessibilityLabel,
          accessibilityLabel = _this$props3$accessib === void 0 ? 'pagination' : _this$props3$accessib,
          _this$props3$contentA = _this$props3.contentAccessibilityLabels,
          contentAccessibilityLabels = _this$props3$contentA === void 0 ? {} : _this$props3$contentA,
          propsCurrentPage = _this$props3.currentPage,
          numPages = _this$props3.numPages,
          _this$props3$pagesAro = _this$props3.pagesAroundCurrent,
          pagesAroundCurrent = _this$props3$pagesAro === void 0 ? 3 : _this$props3$pagesAro,
          _this$props3$pagesBef = _this$props3.pagesBeforeTruncate,
          pagesBeforeTruncate = _this$props3$pagesBef === void 0 ? 10 : _this$props3$pagesBef,
          changePage = _this$props3.changePage;
      var _contentAccessibility = contentAccessibilityLabels.next,
          next = _contentAccessibility === void 0 ? 'go to next page' : _contentAccessibility,
          _contentAccessibility2 = contentAccessibilityLabels.previous,
          previous = _contentAccessibility2 === void 0 ? 'go to previous page' : _contentAccessibility2,
          _contentAccessibility3 = contentAccessibilityLabels.currentPage,
          currentPage = _contentAccessibility3 === void 0 ? function (pageNum) {
        return "you are currently on page ".concat(pageNum);
      } : _contentAccessibility3,
          _contentAccessibility4 = contentAccessibilityLabels.goToPage,
          goToPage = _contentAccessibility4 === void 0 ? function (pageNum) {
        return "go to page ".concat(pageNum);
      } : _contentAccessibility4;
      var pages = [];
      var prevPageDisabled = propsCurrentPage && propsCurrentPage <= 1;
      var nextPageDisabled = propsCurrentPage && propsCurrentPage >= numPages;

      for (var page = 1; page <= numPages; page += 1) {
        if (shouldShowPage(page, propsCurrentPage, numPages, pagesAroundCurrent, pagesBeforeTruncate)) {
          pages.push( /*#__PURE__*/React.createElement(Page, {
            key: page,
            page: page,
            currentPage: propsCurrentPage,
            numPages: numPages,
            pagesAroundCurrent: pagesAroundCurrent,
            pagesBeforeTruncate: pagesBeforeTruncate,
            changePage: changePage,
            currentPageLabel: currentPage(page),
            goToPageLabel: goToPage(page)
          }));
        }
      }

      return /*#__PURE__*/React.createElement("nav", {
        role: "navigation",
        "aria-label": accessibilityLabel
      }, /*#__PURE__*/React.createElement(InlineChildren, {
        size: InlineChildren.Sizes.XxSmall,
        alignItems: InlineChildren.Alignment.Center
      }, /*#__PURE__*/React.createElement(PageNav, {
        "aria-label": previous,
        disabled: prevPageDisabled,
        isDisabled: prevPageDisabled,
        onClick: this.prevPage
      }, /*#__PURE__*/React.createElement(Icon, {
        type: Icon.Types.ChevronLeft,
        color: prevPageDisabled ? Icon.Colors.PaginationNumberedUnselectedForegroundDisabled : Icon.Colors.PaginationNumberedUnselectedForeground
      })), pages, /*#__PURE__*/React.createElement(PageNav, {
        "aria-label": next,
        disabled: nextPageDisabled,
        isDisabled: nextPageDisabled,
        onClick: this.nextPage
      }, /*#__PURE__*/React.createElement(Icon, {
        type: Icon.Types.ChevronRight,
        color: nextPageDisabled ? Icon.Colors.PaginationNumberedUnselectedForegroundDisabled : Icon.Colors.PaginationNumberedUnselectedForeground
      }))));
    }
  }]);

  return Pagination;
}(React.PureComponent);

_defineProperty(Pagination, "defaultProps", {
  accessibilityLabel: 'pagination',
  contentAccessibilityLabels: {
    next: 'go to next page',
    previous: 'go to previous page',
    currentPage: function currentPage(pageNum) {
      return "you are currently on page ".concat(pageNum);
    },
    goToPage: function goToPage(pageNum) {
      return "go to page ".concat(pageNum);
    }
  },
  pagesAroundCurrent: 3,
  pagesBeforeTruncate: 10
});

export { Pagination as default };
